import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/Basics/MDBox";

const InputCode = ({ label, value, onChange, codes, path, disabled }) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "33.333%",
				minWidth: "33.333%"
			}}
		>
			<MDBox sx={{ height: "100%" }}>
				<FormControl fullWidth sx={{ height: "100%" }}>
					<InputLabel id="select-label">{label}</InputLabel>
					<Select
						sx={{ height: "100%" }}
						disabled={disabled}
						labelId="select-label"
						id="select"
						label={label}
						value={value || ""}
						name={path}
						onChange={e => {
							onChange(e.target.value);
						}}
					>
						{codes.map((code, index) => {
							return (
								<MenuItem key={index} value={code.value}>
									{code.label}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</MDBox>
		</Grid>
	);
};
export default InputCode;
